import React from 'react';
import { Box, Typography } from '@mui/material';
import { useDroppable } from '@dnd-kit/core';

import { neutral } from '_lex/_foundations/phxColors';

interface SectionDropZoneProps {
  sectionId: number;
  sectionGuid: string;
  isEmpty: boolean;
  isLocked?: boolean;
}

const SectionDropZone: React.FC<SectionDropZoneProps> = ({ sectionId, sectionGuid, isEmpty, isLocked = false }) => {
  const { isOver, setNodeRef } = useDroppable({
    id: `section-drop-zone-${sectionGuid}`, // Use GUID for unique IDs
    data: {
      type: 'section-drop-zone',
      sectionId,
      sectionGuid, // Pass both for lookup
    },
    disabled: isLocked,
  });

  return (
    <Box
      ref={setNodeRef}
      sx={{
        minHeight: isEmpty ? 100 : 50,
        border: '2px dashed',
        borderColor: isOver ? 'primary.main' : neutral[300],
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: isOver ? 'primary.light' : 'rgba(25, 118, 210, 0.04)',
        transition: 'all 0.2s ease',
        opacity: isOver ? 0.8 : 1,
        mx: 1,
      }}
    >
      {isEmpty && (
        <Typography
          variant='body2'
          color='text.secondary'
          textAlign='center'
          sx={{ px: 3, py: 2 }}
        >
          Drag and drop fields from the left-hand panel to build your form
        </Typography>
      )}
    </Box>
  );
};

export default SectionDropZone;
